import { Component, signal } from '@angular/core';
import { ACTIVITY_COLUMNS_TAB, ACTIVITY_DATA_TAB } from '@features/hosts/constants';
import { ActivityLog } from '@shared';

import { TableComponent } from '@shared';

@Component({
    selector: 'app-activity',
    imports: [TableComponent],
    templateUrl: './activity.component.html',
    styleUrl: './activity.component.scss',
})
export class ActivityComponent {
    /**
     * Signal to track selected rows in the table.
     */
    public selectedRows = signal<ActivityLog[]>([]);

    /**
     * Column definitions for the license table.
     */
    public activityColumns = ACTIVITY_COLUMNS_TAB;

    /**
     * Data for the license table.
     */
    public activityData = ACTIVITY_DATA_TAB;

    /**
     * Handles action click events from the table.
     *Triggers when the user clicks on an action button in the table toolbar.
     *
     * @param event - The action event containing action name and row data
     */
    public onActionClick(event: { action: string; row: any }): void {
        console.log('Action clicked:', event.action, 'Row data:', event.row);
    }

    /**
         * Handles cell click events from the table (for columns with hasRedirect: true).
         *Triggers when the user clicks on a cell that has a redirect link.
    
         * @param event - The cell event containing field name, value, and row data
         */
    public onCellClick(event: { field: string; value: any; row: any }): void {
        console.log('Cell clicked:', event.field, 'Value:', event.value, 'Row data:', event.row);

        // Open single license page in a new window
        if (event.row.id) {
            const url = `/licenses/${event.row.id}`;
            window.open(url, '_blank');
        }
    }

    /**
     * Handles selection change events from the table.
     *Triggers when the user selects or deselects a row.
     *
     * @param selectedRows - The array of currently selected rows
     */
    public onSelectionChange(selectedRows: ActivityLog[]): void {
        this.selectedRows.set(selectedRows);
    }
}
